export type { ChipProps, ChipType } from "./Chip";
export { Chip } from "./Chip";
